// De dónde vino el comprador, desde que llega hasta que paga.
//
// Al entrar desde un anuncio la URL trae fbclid y/o utm_*. Se guardan en
// localStorage (la última llegada con datos pisa a la anterior) y al pagar se
// mandan al servidor junto con las cookies de Meta (_fbp, _fbc). El servidor
// las guarda con el pago y las usa en el Purchase de la API de Conversiones:
// el backend está en otro dominio y no ve esas cookies.

const CLAVE = 'evalpro_atribucion';
const CAMPOS_UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

function leerGuardado() {
  try {
    return JSON.parse(window.localStorage.getItem(CLAVE) || '{}') || {};
  } catch {
    return {};
  }
}

function leerCookie(nombre) {
  try {
    const par = document.cookie.split('; ').find((c) => c.startsWith(`${nombre}=`));
    return par ? decodeURIComponent(par.slice(nombre.length + 1)) : null;
  } catch {
    return null;
  }
}

// Se llama en cada cambio de página: si la URL trae fbclid o UTM, se guardan.
export function guardarAtribucionDeLaUrl() {
  if (typeof window === 'undefined') return;
  try {
    const params = new URL(window.location.href).searchParams;
    const nuevos = {};
    const fbclid = params.get('fbclid');
    if (fbclid) {
      nuevos.fbclid = fbclid;
      nuevos.fbclid_at = Date.now();
    }
    CAMPOS_UTM.forEach((campo) => {
      const valor = params.get(campo);
      if (valor) nuevos[campo] = valor;
    });
    if (!Object.keys(nuevos).length) return;
    // Una llegada nueva con UTM reemplaza los UTM viejos (no se mezclan campañas).
    const previo = leerGuardado();
    const base = CAMPOS_UTM.some((c) => nuevos[c])
      ? Object.fromEntries(Object.entries(previo).filter(([k]) => !CAMPOS_UTM.includes(k)))
      : previo;
    window.localStorage.setItem(CLAVE, JSON.stringify({ ...base, ...nuevos }));
  } catch { /* localStorage bloqueado: se sigue sin atribución */ }
}

// Lo que se manda al servidor al pagar.
export function datosDeAtribucion() {
  if (typeof window === 'undefined') return {};
  const guardado = leerGuardado();
  // _fbc lo arma el píxel al llegar con fbclid. Si no está (cookie borrada o
  // bloqueada), se arma con el formato de Meta: fb.1.<milisegundos>.<fbclid>.
  let fbc = leerCookie('_fbc');
  if (!fbc && guardado.fbclid) {
    fbc = `fb.1.${guardado.fbclid_at || Date.now()}.${guardado.fbclid}`;
  }
  const datos = { fbp: leerCookie('_fbp'), fbc, fbclid: guardado.fbclid };
  CAMPOS_UTM.forEach((campo) => { datos[campo] = guardado[campo]; });
  return Object.fromEntries(Object.entries(datos).filter(([, v]) => v));
}
